// @ts-nocheck
/* eslint-disable */
export var CropState
;(function (CropState) {
  CropState[(CropState['HARVESTABLE'] = 0)] = 'HARVESTABLE'
  CropState[(CropState['GROWING'] = 1)] = 'GROWING'
  CropState[(CropState['DISEASED'] = 2)] = 'DISEASED'
  CropState[(CropState['DEAD'] = 3)] = 'DEAD'
  CropState[(CropState['EMPTY'] = 4)] = 'EMPTY'
  CropState[(CropState['FILLING'] = 5)] = 'FILLING'
})(CropState || (CropState = {}))
